import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class TatterDeskForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    td_batchtype: '1',
                    td_cachetime: '10',
                    td_usevalue: 'T'
                },
                validated: true
            })
        }
    }

    @autobind
    handleChangeBatchType(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                td_batchtype: {
                    $set: item.value
                },
                td_usevalue: {
                    $set: 'T'
                }
            }
        }))
    }

    @autobind
    handleChangeCacheTime(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                td_cachetime: {
                    $set: item.value
                },
                td_usevalue: {
                    $set: 'T'
                }
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin41">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        태터데스크를

                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'첫페이지', value:'1' },
                            { label:'글 상단', value:'2' },
                            { label:'글 하단', value:'3' },
                        ]} selected={data.setting.td_batchtype} onSelect={this.handleChangeBatchType}/>
                        에 표시합니다.
                    </div>
                </div>

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        새 글은

                        <TSelectForm className="opt_set opt_plugin2" items={[
                            { label:'10', value:'10' },
                            { label:'20', value:'20' },
                            { label:'30', value:'30' },
                            { label:'40', value:'40' },
                            { label:'50', value:'50' },
                            { label:'60', value:'60' }
                        ]} selected={data.setting.td_cachetime} onSelect={this.handleChangeCacheTime}/>
                        분 주기로 반영됩니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

TatterDeskForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default TatterDeskForm
